import config from '@config';
import {
  initializeHttp,
  setupCsrfInterceptor,
  setupOrganizationSessionInterceptor,
  setupRequestInterceptor,
} from '@gasbi/shared/common/utils/http';

// No 401 -> login redirect here: the chat signs in through its own session flow (GSB-7774, ADR-0004 §2.3-2.4).
// The chat's own organization session (GSB-8274): a 403 `organization_unavailable` reads its organization again.
const instance = initializeHttp(config.VITE_AGENTS_API_URL, [
  setupRequestInterceptor,
  setupCsrfInterceptor,
  setupOrganizationSessionInterceptor,
]);

export default instance;
